import React, { useMemo, useRef } from "react";
import {
  Box,
  Button,
  Center,
  Circle,
  color,
  Flex,
  FormLabel,
  Heading,
  Input,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import * as api from "../../../services/api";
import epilouge from "@fontsource/epilogue";
import roboto from "@fontsource/roboto";
import swAlert from "sweetalert2";
import First from "./First";
import Second from "./Second";
import Third from "./Third";
import { useDispatch } from "react-redux";
import { authActions } from "../../../redux/actions";

const MultistepCompanySetup = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const FormTitle = ["1", "2"];
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    companyName: "",
    gstNumber: "",
    numberOfEmployees: "",
    websiteLink: "",
    companyAddress: "",
    companyEstablished: "",
    bio: "",
    logo: "",
    date: "",
    month: "",
    year: "",
  });

  const changeHandler = (e) => {
    setFormData((state) => ({
      ...state,
      [e.target.name]: e.target.value,
    }));
  };

  const changeFile = (e) => {
    e.preventDefault();
    const selectedFile = e.target.files[0];
    const fileSize = selectedFile.size;
    const fileSizeMb = fileSize / 1024 ** 2;

    if (fileSizeMb < 5) {
      const allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
      // console.log(selectedFile);
      if (!allowedExtensions.exec(selectedFile?.name)) {
        swAlert.fire({
          icon: "warning",
          text: "Please upload jpg/jpeg/png file...",
          timer: 1300,
        });
        return;
      }
      setFormData((state) => ({
        ...state,
        logo: e.target.files[0],
      }));
      // alert("file is acceptable");
      // swAlert.fire("Logo uploaded successfully...");
    } else {
      swAlert.fire({
        icon: "warning",
        text: "File size should be less than 5MB",
        timer: 1300,
      });
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (
      formData.companyName &&
      formData.bio &&
      formData.companyAddress &&
      formData.companyEstablished &&
      formData.logo &&
      formData.numberOfEmployees &&
      formData.websiteLink
    ) {
      const uploadData = new FormData();
      uploadData.append("companyName", formData.companyName);
      uploadData.append("companyAddress", formData.companyAddress);
      uploadData.append("companyEstablished", formData.companyEstablished);
      uploadData.append("gstNumber", formData.gstNumber);
      uploadData.append("numberOfEmployees", formData.numberOfEmployees);
      uploadData.append("websiteLink", formData.websiteLink);
      uploadData.append("bio", formData.bio);
      uploadData.append("file", formData.logo);

      const response = await api.createCompany(uploadData);
      if (response.status === 201) {
        const user = JSON.parse(localStorage.getItem("user"));
        const response2 = await api.addCompanyToUser(
          response.data.data._id,
          user.email
        );
        if (response2.status === 200) {
          dispatch(authActions.updateUser());
          swAlert.fire({
            icon: "success",
            text: "Company created successfully and added you to company list",
            timer: 1300,
          });
          navigate("/hiring/recruiter/findtalent");
        }

        //   const user = response2.data.user;
      }
      if (response.status === 500) {
        swAlert.fire({
          icon: "warning",
          text: "Something went wrong, please try again later...",
          timer: 1300,
        });
      }
    } else if (formData.logo == "") {
      swAlert.fire({
        icon: "warning",
        text: "Please Upload Logo",
        timer: 1300,
      });
    } else if (formData.companyName == "") {
      swAlert.fire({
        icon: "warning",
        text: "Please Enter Company Name",
        timer: 1300,
      });
    } else if (!formData.numberOfEmployees) {
      swAlert.fire({
        icon: "warning",
        text: "Please Enter No. of Employees",
        timer: 1300,
      });
    } else if (formData.companyEstablished == "") {
      swAlert.fire({
        icon: "warning",
        text: "Please Enter Est. Date",
        timer: 1300,
      });
    } else if (formData.websiteLink == "") {
      swAlert.fire({
        icon: "warning",
        text: "Please Enter Website Link",
        timer: 1300,
      });
    } else if (formData.companyAddress == "") {
      swAlert.fire({
        icon: "warning",
        text: "Please Enter Company Address",
        timer: 1300,
      });
    } else if (formData.bio == "") {
      swAlert.fire({
        icon: "warning",
        text: "Please Enter About Company",
        timer: 1300,
      });
    }
  };

  return (
    <div>
      <Box>
        <Flex
          h={"100vh"}
          align="center"
          justify="center"
          flexDirection="column"
          py={10}
        >
          {page === 0 && (
            <First
              setPage={setPage}
              formData={formData}
              changeHandler={changeHandler}
              changeFile={changeFile}
            />
          )}

          {page === 1 && (
            <Second
              formData={formData}
              setFormData={setFormData}
              changeHandler={changeHandler}
              setPage={setPage}
            />
          )}

          {page === 2 && (
            <Third
              formData={formData}
              setformData={setFormData}
              changeHandler={changeHandler}
              submitHandler={submitHandler}
              setPage={setPage}
            />
          )}

          {/* already registered */}
          <Text
            mt={page === 0 ? 16 : 10}
            fontSize={16}
            fontFamily={"Roboto"}
            // cursor="pointer"
            // onClick={() => {
            //   navigate("/hiring/recruiter/selectCompany");
            // }}
          >
            Company already registered?
            <Link
              style={{
                fontFamily: "Roboto",
                fontWeight: 500,
                textDecoration: "underline",
              }}
              to="/hiring/recruiter/selectCompany"
            >
              Select Company
            </Link>
          </Text>
        </Flex>
      </Box>
    </div>
  );
};
export default MultistepCompanySetup;
